import React from 'react';
import CssBaseline from '@material-ui/core/CssBaseline';
import BrandLogo from '../../components/BrandLogo';
import heroPhoto from '../../assets/images/auth-hero.png';
import { useLoginStyles } from './loginStyles';

interface IProps {
  /** Heading shown at the top of the form column. */
  title: string;
  /** Small line under the heading. */
  subtitle?: string;
  /** Start the form at the top instead of centring it (long forms). */
  alignTop?: boolean;
}

/**
 * Shared shell for the auth screens: brand photo card on the left, form
 * column on the right. On small screens the photo is hidden and the logo
 * moves above the form.
 */
const AuthLayout: React.FC<IProps> = ({
  title,
  subtitle,
  alignTop = false,
  children,
}) => {
  const classes = useLoginStyles();

  return (
    <div className={classes.container}>
      <CssBaseline />

      <aside className={classes.heroPanel} aria-hidden="true">
        <img src={heroPhoto} alt="" className={classes.heroPhoto} />
        <div className={classes.heroOverlay} />
        <div className={classes.heroBrand}>
          <BrandLogo onDark className={classes.heroLogo} />
          <p className={classes.heroTagline}>Your all-in-one learning portal</p>
        </div>
      </aside>

      <main
        className={classes.formPanel}
        style={alignTop ? { justifyContent: 'flex-start' } : undefined}
      >
        <div className={alignTop ? classes.formInnerWide : classes.formInner}>
          <div className={classes.logoWrap}>
            <BrandLogo className={classes.logoImg} />
          </div>

          <h1 className={classes.heading}>{title}</h1>
          {subtitle && <p className={classes.subheading}>{subtitle}</p>}

          {children}
        </div>
      </main>
    </div>
  );
};

export default AuthLayout;
